import React from 'react';
import { useHistory } from 'react-router-dom';


import { renderDate, truncate } from '../../../../helpers';
import { getConfig } from '../../../../utils/config';

const PastEvents = ({ events }) => {
    const history = useHistory();
    const config = getConfig();

    const eventClickedHandler = (eventId) => {
        history.push(`/events/${eventId}`);
    };
    return (
        <>
            <div className={' hidden lg:block w-full  '}>
                <h1
                    className={
                        ' font-semibold px-4 py-2 uppercase text-xl mb-6 mt-8'
                    }
                >
                    Past Events
                </h1>
                <div
                    className={
                        'p-4'
                    }
                >
                    {events.map((data) => {
                        return (
                            <>
                                <div
                                    className={
                                        
                                        ' flex my-2 pb-2 h-[100px] cursor-pointer hover:shadow-inner'
                                    }
                                    onClick={() => eventClickedHandler(data.id)}
                                >
                                    <div className="w-[40%] xl:w-[35%] ">
                                        <img
                                            src={data.displayImageUrl}
                                            className="w-full py-2 xl:pr-3 h-full object-cover"
                                            alt="img"
                                        />
                                    </div>
                                    <div className="w-[65%] xl:w-[70%] px-2 py-2">
                                        <h2
                                            className={
                                                config?.events.eventLayout.titleClass
                            ? config?.events.eventLayout.titleClass
                            : 'capitalize leading-5 font-semibold'
                                                    }
                                        >
                                           
                                            {truncate(data.title, 6) + '..'}
                                        </h2>
                                        
                                        {/* <p
                                         className={
                                            config?.events.eventLayout.hostClass
                                                ? config?.events.eventLayout.hostClass
                                                : ' font-Helvetica_Light capitalize '
                                        }
                                            
                                        >
                                            
                                           {data?.eventHost}
                                        </p> */}
                                       
                                        <p
                                            className='text-xs'
                                        >
                                            {renderDate(
                                                data?.startDate     
                                            )}
                                        </p>
                                    </div>
                                </div>
                            </>
                        );
                    })}
                </div>
            </div>
        </>
    );
};

export default PastEvents;

